import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_SUB_AZURE, GET_SUB_AZURE_SUCCESS, GET_SUB_AZURE_ERROR
} from './constant';


const initialState = {
  phase: INIT,
  azureSubList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
 

export function AzureSubStore(state = initialState, action) {
  switch (action.type) {
    case GET_SUB_AZURE:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_SUB_AZURE_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureSubList: action.data,
        error: null,
      };
    case GET_SUB_AZURE_ERROR:
      return { ...state, phase: ERROR, error: action.error };





    default:
      return state;
  }
}
